import {
	SIDE_NAV_LIGHT,
	NAV_TYPE_SIDE,
	DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "treino.io";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const CONVITE_PREFIX_PATH = "/c";
export const REGISTRO_PREFIX_PATH = "/registro";
export const REGISTRO_ESPECIAL_LIVE_PREFIX_PATH = "/especial-live";
export const DARKSIDE_PREFIX_PATH = "/darkside";
export const ANIVERSARIO_PREFIX_PATH = "/oferta-aniversario";
// ID do plano contratual da oferta de aniversário. Em local = 10; substituir
// pelo ID real após a migration rodar em produção.
export const ID_PLANO_ANIVERSARIO = 10;
// Cutoff da promoção: 06/05/2026 00:00 BRT (= 03:00 UTC).
export const CUTOFF_ANIVERSARIO_MS = Date.UTC(2026, 4, 6, 3, 0, 0);
export const CONDICAO_UNICA_PREFIX_PATH = "/condicao-unica";
export const CODIGO_CUPOM_CONDICAO_UNICA = "ELEVAR_NIVEL_2026";
export const TERMOS_PREFIX_PATH = "/termos";

export const PUBLIC_PREFIX_PATH = env.PUBLIC_PREFIX_PATH;

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: "pt",
	navType: NAV_TYPE_SIDE,
	topNavColor: "#3e82f7",
	headerNavColor: "",
	mobileNav: false,
	currentTheme: "light",
	direction: DIR_LTR,
};
